export const encryptionKeys = {
  IV: '9PLQTNVhJcRsbPTU',
  key: 'MKOIJNQASDFVRGHNBHUCFTXDRTTYUA'
};
export const paymentMethod = {
  1: 'Masarat',
  2: 'Sadad'
};